import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

const GanttChart = ({ cronograma }) => {
  // 1. PROCESSAR DADOS
  const etapas = cronograma.map((item) => item.descricao) || [];
  const colors = [
    "rgba(52, 152, 219, 0.7)",
    "rgba(46, 204, 113, 0.7)",
    "rgba(155, 89, 182, 0.7)",
    "rgba(241, 196, 15, 0.7)",
    "rgba(230, 126, 34, 0.7)",
    "rgba(52, 73, 94, 0.7)",
  ];

  const deslocamentos = cronograma.map((item) => {
    // AVISO: Esta lógica depende da estrutura de dados da tua rota /cronograma
    const meses = (item.mensal || [])
      .filter((p) => p.valor_simples > 0)
      .map((p) => p.mes);
    if (!meses.length) return { inicio: 0, duracao: 0 };
    const inicio = Math.min(...meses);
    const fim = Math.max(...meses);
    return { inicio, duracao: fim - inicio + 1 };
  });

  // 2. DEFINIR DADOS (Esta é a versão correta)
  const data = {
    labels: etapas,
    datasets: [
      {
        label: "Deslocamento",
        // Lógica correta: (inicio - 1) para o offset
        data: deslocamentos.map((d) => (d.inicio > 0 ? d.inicio - 1 : 0)),
        backgroundColor: "transparent",
        stack: "Cronograma",
      },
      {
        label: "Meses do Cronograma",
        data: deslocamentos.map((d) => d.duracao),
        backgroundColor: colors,
        borderColor: colors.map((c) => c.replace("0.7", "1")),
        borderWidth: 1,
        borderRadius: 5,
        barPercentage: 0.8,
        stack: "Cronograma",
      },
    ],
  };

  // 3. DEFINIR OPÇÕES (Esta é la versão correta)
  const options = {
    indexAxis: "y", // Gráfico de barras horizontal
    responsive: true,
    maintainAspectRatio: false, // Permite que o 'height' do div funcione
    plugins: {
      legend: { display: false }, // Esconde a legenda (já que temos uma manual)
      title: {
        display: true,
        text: "Cronograma do Projeto",
        font: { size: 20 },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const dataIndex = context.dataIndex;
            if (dataIndex < 0 || dataIndex >= deslocamentos.length) {
              return "Sem dados";
            }

            const d = deslocamentos[dataIndex];
            if (d.duracao === 0) return ["Sem parcelas"];

            return [
              `Mês início: ${d.inicio}`,
              `Mês fim: ${d.inicio + d.duracao - 1}`,
              `Duração: ${d.duracao} meses`,
            ];
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: "rgba(0,0,0,0.1)" },
        min: 0, // Lógica correta: min: 0
        ticks: {
          callback: (val) => (val === 0 ? "" : `M${val}`), // Oculta o "Mês 0"
          stepSize: 1,
        },
      },
      y: { stacked: true, grid: { display: false } },
    },
  };

  // 4. RENDERIZAR O GRÁFICO (Limpando a redundância)
  return (
    <div
      className="gantt-chart"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        margin: 0,
        padding: 0,
      }}
    >
      <div style={{ width: "100%", height: "400px" }}>
        {/* Agora usa as constantes 'data' e 'options' definidas acima */}
        <Bar data={data} options={options} />
      </div>

      <div
        className="gantt-legend"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        {etapas.map((etapa, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "15px",
              marginBottom: "5px",
            }}
          >
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: colors[index % colors.length],
                marginRight: "5px",
                borderRadius: "4px",
              }}
            />
            <span>{etapa}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GanttChart;
